import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {DialogData_VersionDialogInput, DialogData_VersionDialogOutput} from "../version-dialog/version-dialog.component";

export interface DialogData_GeneralWarningDialogInput extends MatDialogDataBaseInput {
	warningTitle: string;
	warningDescription: string;
	warningOkText?: string;
	showOnlyConfirmation?: boolean;
}

export interface DialogData_GeneralWarningDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-general-warning-dialog",
	templateUrl: "./general-warning-dialog.component.html",
	styleUrls: ["./general-warning-dialog.component.scss"],
	standalone: false,
})
export class GeneralWarningDialogComponent extends BasicMaterialDialog<
	GeneralWarningDialogComponent,
	DialogData_GeneralWarningDialogInput,
	DialogData_GeneralWarningDialogOutput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}
}
